import React, { useEffect, useRef, useState } from "react";
import { cofRequest } from "../../api/cof";
import { getOccupiedSlots } from "../../api/cof";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import { Html5Qrcode } from "html5-qrcode";
import Section from "./Section";
import "./cofrequest.css";
import { FaObjectUngroup } from "react-icons/fa";

const COFRequest = () => {
  const [formData, setFormData] = useState({
    requestDate: "",
    timeSlot: "",
    vesselNumber: "",
  });
  const today = new Date().toISOString().split("T")[0];
  const [timeSlots, setTimeSlots] = useState([
    "08:00 - 09:00",
    "09:00 - 10:00",
    "10:00 - 11:00",
    "11:00 - 12:00",
    "12:00 - 13:00",
    "13:00 - 14:00",
    "14:00 - 15:00",
    "15:00 - 16:00",
    "16:00 - 17:00",
  ]);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([...timeSlots]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeVesselNumber = (selectedOption) => {
    alert(selectedOption?.value);
    setFormData({
      ...formData,
      vesselNumber: selectedOption ? selectedOption?.value : "", // Update 'vesselNumber' based on the selected option
    });
  };

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const handleDateChange = async (event) => {
    const selectedDate = event.target.value; // Get the selected date from the input field
    setFormData((prevData) => ({
      ...prevData,
      requestDate: selectedDate,
    }));

    try {
      const response = await getOccupiedSlots(selectedDate); // Fetch occupied slots for the selected date
      const occupiedSlots = response.data.timeSlots; // Adjust based on your API response structure

      // Filter out occupied time slots
      const updatedSlots = timeSlots.filter(
        (slot) => !occupiedSlots.includes(slot)
      );

      setAvailableTimeSlots(updatedSlots);
    } catch (error) {
      console.error("Error fetching occupied time slots:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    await cofRequest(formData);
    // Add your request submission logic here
  };

  return (
    <React.Fragment>
      {/* <Section /> */}
      <section className="section">
        <Container>
          <Col md={6} className="mx-auto text-center">
            <Form onSubmit={handleSubmit}>
              {/* Date Picker */}
              <FormGroup>
                <Label for="date">Select Date</Label>
                <Input
                  type="date"
                  id="requestDate"
                  name="requestDate"
                  value={formData.requestDate}
                  onChange={handleDateChange}
                  min={today}
                  required
                />
              </FormGroup>

              {/* Time Slot Picker */}
              <FormGroup>
                <Label for="timeSlot">Select Time Slot</Label>
                <Input
                  type="select"
                  id="timeSlot"
                  name="timeSlot"
                  value={formData.timeSlot}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Choose a time slot
                  </option>
                  {availableTimeSlots.map((slot, index) => (
                    <option key={index} value={slot}>
                      {slot}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              {/* Boat Selector */}
              <FormGroup>
                <Label for="boat">Select Vessel</Label>

                <Select
                  options={options}
                  onChange={handleChangeVesselNumber}
                  value={
                    options.find(
                      (option) => option.value === formData.vesselNumber
                    ) || null
                  } // If no vesselNumber, set to null
                  placeholder="Select an option"
                  isClearable
                  isSearchable={true} // Enables typing to search
                  requried
                />
              </FormGroup>

              {/* Submit Button */}
              <Button
                color="primary"
                type="submit"
                style={{ marginBottom: "20px" }}
                lock
              >
                Request
              </Button>
            </Form>
          </Col>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default COFRequest;
